import { render, staticRenderFns } from "./OnboardingPrivacyPolicy.vue?vue&type=template&id=ff5deea0&"
import script from "./OnboardingPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./OnboardingPrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports